import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-steps",
  "use": "icon-th-steps-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-steps\">\n<path d=\"M31 7C31 7.26522 30.8946 7.51957 30.7071 7.70711C30.5196 7.89464 30.2652 8 30 8H24V13C24 13.2652 23.8946 13.5196 23.7071 13.7071C23.5196 13.8946 23.2652 14 23 14H17V19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H10V25C10 25.2652 9.89464 25.5196 9.70711 25.7071C9.51957 25.8946 9.26522 26 9 26H2C1.73478 26 1.48043 25.8946 1.29289 25.7071C1.10536 25.5196 1 25.2652 1 25C1 24.7348 1.10536 24.4804 1.29289 24.2929C1.48043 24.1054 1.73478 24 2 24H8V19C8 18.7348 8.10536 18.4804 8.29289 18.2929C8.48043 18.1054 8.73478 18 9 18H15V13C15 12.7348 15.1054 12.4804 15.2929 12.2929C15.4804 12.1054 15.7348 12 16 12H22V7C22 6.73478 22.1054 6.48043 22.2929 6.29289C22.4804 6.10536 22.7348 6 23 6H30C30.2652 6 30.5196 6.10536 30.7071 6.29289C30.8946 6.48043 31 6.73478 31 7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-steps.svg
// module id = gvvm
// module chunks = 84